<script setup>

import {onMounted, ref} from "vue";
import Modal from "./Modal.vue";
import FeaturedImage from "../Helpers/FeaturedImage";

const props = defineProps({
    speakers: Array,
});

const activeSpeakerSlug = ref(null);
const modalElement = document.getElementById('modal');

const openSpeakerModal = (speaker_slug) => {
    if (speaker_slug === '' || speaker_slug === '#') {
        return;
    }

    speaker_slug = speaker_slug.startsWith('#') ? speaker_slug.substring(1) : speaker_slug;

    window.location.hash = `#${speaker_slug}`;
    activeSpeakerSlug.value = speaker_slug;
}

const closeModal = () => {
    window.location.hash = '';
    activeSpeakerSlug.value = null;
}

const changeSpeaker = (speaker_slug) => {
    openSpeakerModal(speaker_slug);
}

onMounted(() => {
    openSpeakerModal(window.location.hash);
});

</script>

<template>
    <ul>
        <li v-for="speaker in speakers" @click="openSpeakerModal(speaker.slug)" :key="speaker.slug">
            <div>
                <figure>
                    <picture><img :src="FeaturedImage.getSpeakerFeaturedImageUrl(speaker)" alt=""></picture>
                </figure>
                <h3>{{ speaker['name'] }}</h3>
                <p>{{ speaker['bio'] }}</p>
                <p>{{speaker['company']}}</p>
            </div>
        </li>
    </ul>
    <Modal :activeSpeakerSlug="activeSpeakerSlug" @closeModal="closeModal" @changeSpeaker="changeSpeaker"/>
</template>

<style scoped>

</style>
